/* iCase: el buscador "escribe" frases de ejemplo con un cursor que titila */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(field) {
    if (field.dataset.typingReady) return;
    field.dataset.typingReady = '1';
    var input = field.querySelector('input');
    var out = field.querySelector('[data-typing-text]');
    var phrases = (field.getAttribute('data-phrases') || '').split('|').filter(function (p) { return p.trim(); });
    if (!input || !out || !phrases.length) return;

    var speed = Number(field.getAttribute('data-speed')) || 60;
    var i = 0, pos = 0, deleting = false, timer = null;

    function idle() { return !input.value && document.activeElement !== input; }
    function sync() { field.classList.toggle('is-typing', idle()); }

    function tick() {
      clearTimeout(timer);
      if (!idle()) { sync(); return; }
      sync();
      var word = phrases[i];
      if (!deleting) {
        pos++;
        out.textContent = word.slice(0, pos);
        if (pos >= word.length) { deleting = true; field.classList.add('is-paused'); timer = setTimeout(function () { field.classList.remove('is-paused'); tick(); }, 1800); return; }
        timer = setTimeout(tick, speed + Math.random() * speed * 0.6);
      } else {
        pos--;
        out.textContent = word.slice(0, pos);
        if (pos <= 0) { deleting = false; i = (i + 1) % phrases.length; timer = setTimeout(tick, 400); return; }
        timer = setTimeout(tick, Math.max(18, speed * 0.45));
      }
    }

    if (reduce) {
      out.textContent = phrases[0];
      field.classList.add('is-paused');
      input.addEventListener('focus', sync);
      input.addEventListener('blur', sync);
      input.addEventListener('input', sync);
      sync();
      return;
    }

    input.addEventListener('focus', function () { clearTimeout(timer); sync(); });
    input.addEventListener('input', sync);
    input.addEventListener('blur', function () {
      if (!input.value) { pos = 0; deleting = false; out.textContent = ''; timer = setTimeout(tick, 600); }
      sync();
    });

    timer = setTimeout(tick, 700);
  }

  function boot() { document.querySelectorAll('[data-typing]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
